import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Phase 1 — Marketing + forms
import Marketing from './Marketing';
import Book from './pages/Book';
import Estimate from './pages/Estimate';

// Services — flat-rate menu (Phase 8 polish)
import Services from './Services';

// Legal pages
import Privacy from './Privacy';
import Terms from './Terms';

// Phase 2 — AdminV2 + Tech portal
import AdminV2 from './AdminV2';
import Tech from './Tech';

// Phase 5 — Tokenized estimate approval (public)
import EstimateApproval from './EstimateApproval';

export default function App() {
  return (
    <Routes>
      {/* Marketing — single-page site */}
      <Route path="/" element={<Marketing />} />

      {/* Lead capture forms */}
      <Route path="/book" element={<Book />} />
      <Route path="/estimate" element={<Estimate />} />

      {/* Flat-rate services menu */}
      <Route path="/services" element={<Services />} />

      {/* Legal */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />

      {/* Public tokenized estimate approval */}
      <Route path="/estimate/:token" element={<EstimateApproval />} />

      {/* Admin CRM */}
      <Route path="/admin-new" element={<AdminV2 />} />
      <Route path="/admin-new/*" element={<AdminV2 />} />

      {/* Tech portal */}
      <Route path="/tech" element={<Tech />} />
      <Route path="/tech/*" element={<Tech />} />

      {/* Fallback */}
      <Route path="*" element={<Marketing />} />
    </Routes>
  );
}
